module.exports = __webpack_public_path__ + "static/media/img87.5187c6f7.jpg";